import type { NonAgentJsonType } from '@bb/domain/dist/types/NonAgent';
import axios, { type AxiosRequestConfig } from 'axios';

const save = async (
  nonAgent: Omit<
    NonAgentJsonType,
    | '_id'
    | 'id'
    | 'createdBy'
    | 'createdAt'
    | 'org'
    | 'isDeleted'
    | 'onboardingPortalId'
    | 'preApproved'
    | 'uid'
    | 'updatedAt'
    | 'updatedBy'
  >,
) => {
  const config: AxiosRequestConfig = {
    url: '/nonagent',
    method: 'post',
    data: nonAgent,
  };

  const { data } = await axios.request<NonAgentJsonType>(config);
  return data;
};
export default save;
